import headerImg from '../../../assets/developers/devbanner.svg'

import ease from '../../../assets/developers/ease.svg'
import growth from '../../../assets/developers/growth.svg'
import speed from '../../../assets/developers/speed.svg'

import whyChoose from '../../../assets/developers/whyChoose.svg'


export const headerData = {
    title: 'SQA Engineer',
    title2: 'Developers',
    desc: 'A software quality assurance (SQA) engineer is a professional who is responsible for ensuring the quality and reliability of software products. They work throughout the software development life cycle, from the planning and design stages through to the testing and deployment stages. SQA engineers are responsible for developing and executing test plans, identifying and documenting defects, and ensuring that software products meet the required standards and specifications.',
    points: [
        'Quick deployment',
        'An active community with open-source solutions',
        'Shorter time-to-market circle',
    ],
    img: headerImg
}

export const achiveData = {
    title1: 'What can you Achieve with the right',
    title2: 'SQA Engineer Developers?',
    desc: "You need a SQA Engineer team that never compromises on your project’s success determinants. Let's find out what a field-proven team looks like",
    cards: [
        {
            title: 'Growth with Confidence',
            desc: 'Start small but go big with CodeZone’s SQA Engineer developers, who leverage seamless and cost-effective cloud computing tools to expand your user base.',
            img: ease
        },
        {
            title: 'Ease of Flexibility',
            desc: 'Node-to-node technology facilitates SQA Engineer developers to smoothly integrate changes without altering the core programming source, contributing to easier maintenance.',
            img: growth
        },
        {
            title: 'Speed and Performance',
            desc: 'SQA Engineer experts integrate uninterrupted speed and performance to handle high traffic, making SQA Engineer an ideal framework for developing user-centric apps.',
            img: speed
        },


    ]
}

export const partnerData = {
    title1: 'Partner With CodeZone for Future-forward',
    title2: 'SQA Engineer App Development Services',

    cards: [
        {
            title: 'Truly Agile Procedures',
            desc: "CodeZone's SQA Engineer developers follow the time-tested agile practices throughout the software development life cycle — ensuring efficiency and transparency.",
        },
        {
            title: 'Custom SQA Engineer development services',
            desc: 'CodeZone is a houseful of SQA Engineer experts and tech stack that fit faultlessly with your product and company culture.',
        },
        {
            title: 'Market competitive Rates',
            desc: "We provide silicon-valley level SQA Engineer experts under budget-friendly pricing. With us, you wouldn't have to worry about your budget and the quality, because we care for both.",
        },
        {
            title: 'Dedicated SQA Engineer Mobile App Development Teams',
            desc: "The dedicated development team co-acts with your in-house team. Borders, languages, or cultures never stop us from delivering a global enterprise-level product.",
        },


    ]
}

export const whyChooseData = {
    title: 'SQA Engineer',
    desc: 'Easy. Awesome. Powerful. Fast. Flexible. Fun. – All under SQA Engineer Umbrella.',
    img: whyChoose,
    cards: [
        {
            title: 'High Performance',
            desc: 'Outperform the competition with the single-threaded and event-driven architecture of SQA Engineer.'
        },
        {
            title: 'Easy Scalability',
            desc: 'Handle a huge number of concurrent connections and develop lightweight systems with SQA Engineer.'
        },
        {
            title: 'Microservices',
            desc: 'Build powerful microservice-based web applications with SQA Engineer developers.'
        },
        {
            title: 'Custom Software Development',
            desc: 'Leverage built-in API through SQA Engineer as it can be easily extended and customized.'
        },
        {
            title: 'Fast Time-to-Market',
            desc: 'Speed up the development process with multiple frameworks and libraries of SQA Engineer.'
        },
        {
            title: 'Community Support',
            desc: 'Expect extensive support from hawk-eyed developers of the SQA Engineer community.'
        },
    ]
}

export const HowToData = {
    title: 'SQA Engineer developers',
    desc: 'A meticulous process for impeccable product launch without any delays',
}

export const FAQData = [
    {
        question: 'What is a software quality assurance (SQA) engineer?',
        answer: 'A software quality assurance (SQA) engineer is a professional who is responsible for ensuring the quality and reliability of software products.'
    },
    {
        question: 'What is the role of SQA engineering in software development?',
        answer: 'SQA engineering is an important field in the software development industry, as the quality and reliability of software products are essential for ensuring customer satisfaction and business success. SQA engineers play a crucial role in ensuring that software products meet the required standards and specifications and are delivered on time and within budget.'
    },
    {
        question: 'What are the benefits of SQA engineering?',
        answer: "SQA engineering can improve the quality and reliability of software products, which can lead to increased customer satisfaction and business success. It can also reduce the risk of defects and errors in software products, which can lead to cost savings and increased efficiency."
    },


]